import { Box, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AccountStatus } from "../../api/psc";
import { AuthenticationContext } from "../../contexts/AuthenticationContext";
import { UserContext } from "../../contexts/UserContext";
import NationalAuthentication from "../../features/accounts/NationalAuthentication";
import { useTutorialContext } from "../../features/tutorialModule/TutorialContext";
import TutorialWrapper from "../../features/tutorialModule/TutorialWrapper";
import { useAppSelector } from "../../hooks/reduxHooks";
import { getAuthManager } from "../../utils/auth";
import CustomizedAppBar from "../layouts/CustomizedAppBar";
import CustomizedDrawer from "../layouts/CustomizedDrawer";
import SuspiciousAccountPage from "../SuspiciousAccountPage";

export default function PageScaffold(props: { showMenu: boolean }) {
    const user = useContext(UserContext);
    const navigate = useNavigate();

    const authManager = getAuthManager();

    const { requireAuthenticatedUser } = useContext(AuthenticationContext);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const sharedState = useAppSelector((state) => state.shared);
    const { startTutorial, activeStep, stopTutorial } = useTutorialContext();

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    const isImpersonation = authManager.isImpersonated;

    useEffect(() => {
        requireAuthenticatedUser();
    }, []);

    // const updateOnboarding = async () => {
    //     const isProjectsRoute = window.location.pathname === "/";
    //     if (!isProjectsRoute && activeStep === null) {
    //         navigate("/");
    //     }

    //     if (activeStep === null) {
    //         await AccountService.updateOnboarding("1", {
    //             step: AccountOnboardingStep.TUTORIAL,
    //         });
    //         startTutorial();
    //     }
    // };
    // useEffect(() => {
    //     if (sharedState?.accountDetail?.shouldRunOnboarding) {
    //         updateOnboarding();
    //     }
    // }, [sharedState?.accountDetail?.shouldRunOnboarding]);

    if (!user) {
        return <></>;
    }

    if (sharedState.accountDetail.shouldAuthenticate) {
        return <NationalAuthentication />;
    }

    if (sharedState.accountDetail.status === AccountStatus.SUSPICIOUS) {
        return <SuspiciousAccountPage />;
    }

    const handleNextStep = (a: string) => {
        if (a == "desktop-signup-10" || a === "mobile-signup-12") {
            if (sharedState.accountDetail.shouldRunOnboarding) {
                navigate("/gift");
            } else {
                stopTutorial();
            }
        }
    };

    return (
        <Stack sx={{ height: "100dvh", overflow: "hidden" }} direction="column">
            {/* show menu if the route requires  */}
            {props.showMenu ? (
                <>
                    <CustomizedAppBar
                        isImpersonated={isImpersonation}
                        toggleDrawer={toggleDrawer}
                    />
                    <CustomizedDrawer
                        toggleDrawer={toggleDrawer}
                        drawerOpen={drawerOpen}
                    />
                </>
            ) : (
                <></>
            )}

            <Box
                sx={{
                    overflow: "auto",
                    height: "100%",
                    flex: 1,
                    mt: props.showMenu ? 8 : 2,
                    position: "relative",
                }}
            >
                <Outlet />
            </Box>

            <TutorialWrapper
                steps={[
                    "desktop-signup-1",
                    "desktop-signup-2",
                    "desktop-signup-3",
                    "mobile-signup-1",
                    "mobile-signup-2",
                    "desktop-signup-8",
                    "desktop-signup-10",
                    "mobile-signup-10",
                    "mobile-signup-12",
                ]}
                onNextStep={handleNextStep}
            ></TutorialWrapper>
        </Stack>
    );
}
